import Vue from "vue";
import axios from "axios";
import "src/material/global/vendor/jquery-ui/core";
import "src/material/global/vendor/jquery-ui/widget";
import "src/material/global/vendor/jquery-ui/widgets/draggable";
import "src/material/global/vendor/jquery-ui/widgets/droppable";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import store from "../../../store";
import mixin from "../../../mixins/mixin";
import calendarScroll from "../../../mixins/calendarScroll";
import rentalService from "./../../../services/rental";
import bookingService from "./../../../services/booking";
import accountService from "../../../services/account";
import bookingComService from "../../../services/booking-com";
import formService from "../../../services/form";

export default {
  data() {
    return {
      en: en,
      fr: fr,
      disabledDates: {
        from: moment().add(2, "years").toDate(),
      },
      currentMonth: 1,
      from: "",
      to: "",
      rentals: [],
      months: [],
      month_numbers: [],
      allMonths: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      years: [],
      loading: true,
      months_with_days: [],
      array_dates: [],
      array_correct_dates: [],
      valid_dates: [],
      show_detail_modal: false,
      calendar_type: false,
      paymentStatus: "",
      depositStatus: "",
      booking: {
        rental: {
          the_keys_locks: [],
        },
      },
      guest: [],
      rental: {
        the_keys_locks: [],
      },
      channel: [],
      mode: "month",
      selectedRental: "",
      selectedBookingRental: {
        the_keys_locks: [],
      },
      allRentals: [],
      week_days: [],
      bookingDetails: false,
      language: localStorage.getItem("lang") || "fr",
      editPrice: {
        default_persone_count: 1,
        selected_week_days: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        week_days: [
          {
            selected: true,
            name: "mo",
            full_name: "Monday",
          },
          {
            selected: true,
            name: "tu",
            full_name: "Tuesday",
          },
          {
            selected: true,
            name: "we",
            full_name: "Wednesday",
          },
          {
            selected: true,
            name: "th",
            full_name: "Thursday",
          },
          {
            selected: true,
            name: "fr",
            full_name: "Friday",
          },
          {
            selected: true,
            name: "sa",
            full_name: "Saturday",
          },
          {
            selected: true,
            name: "su",
            full_name: "Sunday",
          },
        ],
        rental: {},
        startDate: null,
        endDate: null,
      },
      rentalMinStayData: {
        startDate: moment().toDate(),
        endDate: moment().add(1, "day").toDate(),
        minStay: "",
        rental: "",
        rentalName: "",
        default_persone_count: 1,
        selectedWeekDays: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
        ],
        weekDays: [
          {
            selected: true,
            name: "mo",
            full_name: "Monday",
          },
          {
            selected: true,
            name: "tu",
            full_name: "Tuesday",
          },
          {
            selected: true,
            name: "we",
            full_name: "Wednesday",
          },
          {
            selected: true,
            name: "th",
            full_name: "Thursday",
          },
          {
            selected: true,
            name: "fr",
            full_name: "Friday",
          },
          {
            selected: true,
            name: "sa",
            full_name: "Saturday",
          },
          {
            selected: true,
            name: "su",
            full_name: "Sunday",
          },
        ],
      },
      selectedWeekDays: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      weekDays: [
        {
          selected: true,
          name: "mo",
          full_name: "Monday",
        },
        {
          selected: true,
          name: "tu",
          full_name: "Tuesday",
        },
        {
          selected: true,
          name: "we",
          full_name: "Wednesday",
        },
        {
          selected: true,
          name: "th",
          full_name: "Thursday",
        },
        {
          selected: true,
          name: "fr",
          full_name: "Friday",
        },
        {
          selected: true,
          name: "sa",
          full_name: "Saturday",
        },
        {
          selected: true,
          name: "su",
          full_name: "Sunday",
        },
      ],
      showPriceSetup: false,
      editRentalMinStay: false,
      onceWatchedInMounted: 0,
      closedEditPriceModal: false,
      editPriceView: false,
      startDate: {
        disabled: {
          to: null,
          from: moment().add(2, "years").toDate(),
        },
      },
      endDate: {
        disabled: {
          to: null,
          from: moment().add(2, "years").toDate(),
        },
      },
      is_clicked: 0,
      user: {
        is_team_member: "",
        rights: {},
        currency: {},
      },
      showBookingActions: false,
      showBookingPrices: false,
      groups: [],
      others: [],
      checkedRentals: {},
      canSaveCheckedRentals: false,
      checkedGroups: {},
      filteredRentalValue: "",
      filteredRentalGroups: [],
      rentalsFilteredOnCalendar: [],
      rentalsFilteredOnCalendarValue: "",
      rentalsFilteredOnCalendarThrottle: null,
      rentalsFilteredOnCalendarNoRentals: false,
      rentalsFilteredCount: 10,
      smallLoading: false,
      accessToPlanning: false,
      accessToDaily: false,
      accessToWeekly: false,
      accessToAnnual: false,
      accessToTasks: true,
      isSubscriptionActive: false,
      maxStayData: {
        startDate: null,
        endDate: null,
        maxStayNumber: "",
        rentalId: "",
      },
      maxStayPanelOpened: false,
      overrideData: {
        startDate: null,
        endDate: null,
        status: "",
        rentalId: "",
      },
      overridePanelOpened: false,
      rateCodes: [],
      rentalRateLoading: false,
      inventoryData: {
        startDate: null,
        endDate: null,
        inventoryNumber: "",
        rentalId: "",
      },
      inventoryPanelOpened: false,
      singleUseData: {
        startDate: null,
        endDate: null,
        singleUseNumber: "",
        rentalId: "",
        rental: "",
      },
      singleUsePanelOpened: false,
      restrictions: {
        minStay: {
          checked: false,
          name: "min_stay.title",
        },
        override: {
          checked: false,
          name: "override.title",
        },
        inventory: {
          checked: false,
          name: "inventory_title",
        },
      },
      membersForChecking: [],
      membersForCheckout: [],
      currentMonthStartDay: moment().startOf("month").format("YYYY-MM-DD"),
      nextMonthStartDay: moment(this.currentMonthStartDay)
        .add(1, "M")
        .startOf("month")
        .format("YYYY-MM-DD"),
      weekDaysInfo: {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      },
      agentaBookings: [],
      isFirstWatch: false,
      currentRental: {},
      priceToEdit: {},
      isUpdatedValue: false,
      enableMultipleModification: false,
      enableOpenModal: false,
      disabledCheckbox: false,
      currentRestrictionName: "price",
      minStayRentalsIds: [],
      inventoryRentalsIds: [],
      overrideRentalsIds: [],
      accountIsGot: false,
      hasPermissionForMultiSelect: false,
      allRentalsGroups: [],
      userAllRentals: [],
      gotAllRentals: false,
      bookingUrl: null,
      changeAvailability: false,
      showRestrictionType: "price",
      cellSize: 20,
      rentalsCount: 0,
      priceError: null,
    };
  },
  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    Datepicker,
    VLoading: require("components/loading/loading.vue"),
    VManageLocks: require("components/manage-locks/manage-locks.vue"),
    VExportBookings: require("components/export-bookings/export-bookings.vue"),
    VCurrent: require("../../analytics/current/current.vue"),
    VScheduler: require("../scheduler/assign/assign.vue"),
    VBillingModal: require("../../../layouts/default/billing-modal"),
    VEditMinStay: require("./EditMinStay"),
    VImportNewAirbnbRentals: require("../../account/settings/modals/ImportNewAirbnbRentals"),
    VTasks: require("../scheduler/task-management/TaskLists"),
    VOverride: require("./Override"),
    VInventory: require("./Inventory"),
    VImportBookingsFromFile: require("../../rentals/detail/modals/ImportBookingsFromFile"),
    VMultiSelect: require("./MultiSelect"),
    VSyncInProgressModal: require("components/sync-in-progress-modal/modal.vue"),
    VSyncTmpChangeModal: require("components/sync-tmp-change-modal/modal.vue"),
    VSyncTmpChangeModalReservations: require("components/sync-tmp-change-modal-reservations/modal.vue"),
  },
  mixins: [mixin, calendarScroll],
  watch: {
    checkedRentals: {
      handler(newValue, oldValue) {
        // if(newValue != oldValue) {
        //   this.canSaveCheckedRentals = true;
        // }else{
        //   this.canSaveCheckedRentals = false;
        // }
        // console.log(Object.keys(newValue).filter(r => newValue[r]).length);
      },
    },
    rentalsFilteredOnCalendarValue(val) {
      clearTimeout(this.rentalsFilteredOnCalendarThrottle);
      this.rentalsFilteredOnCalendarThrottle = setTimeout((_) => {
        if (val && val.length > 2) {
          let from = this.from;
          let to = this.to;

          let url = `search=${val}`;
          if (from.length > 0) {
            url += `&from=${from}`;
          }
          if (to.length > 0) {
            url += `&to=${to}`;
          }

          axios.get(`/get-calendars?${url}`).then((r) => {
            this.prepare_data(r);
          });
        } else {
          this.rentalsFilteredOnCalendar = this.rentals;
        }
      }, 800);
    },
    filteredRentalValue(val) {
      if (val) {
        const result = [];
        for (const group of this.groups) {
          const filteredGroup = { id: group.id, name: group.name, rentals: [] };

          for (const rental of group.rentals) {
            if (rental.name.toLowerCase().includes(val.toLowerCase())) {
              filteredGroup.rentals.push({ id: rental.id, name: rental.name });
            }
          }
          result.push(filteredGroup);
        }

        this.filteredRentalGroups = result;
      } else {
        this.filteredRentalGroups = this.groups;
      }
    },
    allRentalsGroups(val) {
      const rentals = [];
      const groups = [...val];
      groups.map((group) => {
        group.rentals.map((rental) => {
          rentals.push(rental);
        });
      });
      this.userAllRentals = rentals;
      this.gotAllRentals = true;

      // document.querySelector(".quick-actions").style.top = document.querySelector("#group-selector").offsetHeight + "px";
    },
    gotAllRentals(val) {
      if (val && this.accountIsGot) {
        this.hasPermissionForMultiSelect = this.multiSelectPermission(
          this.enableOpenModal
        );
      }
    },
    enableOpenModal(val) {
      this.hasPermissionForMultiSelect = this.multiSelectPermission(val);
    },
    accountIsGot(val) {
      if (val && this.gotAllRentals) {
        this.hasPermissionForMultiSelect = this.multiSelectPermission(
          this.enableOpenModal
        );
      }
    },
    "$route.params.type": function (newType) {
      this.changeMode(newType);
    },
    selectedRental() {
      this.get_rentals();
    },
    "editPrice.startDate": function () {
      this.checkStartDateDisabledDays();
    },
    "editPrice.endDate": function () {
      this.checkEndDateDisabledDays();
    },
    "account.lang": function (newVal) {
      this.language = newVal;
      this.accountIsGot = true;
      Vue.config.lang = newVal;
    },
    account: {
      async handler(newVal) {
        this.accountIsGot = true;
        if (newVal && newVal.id && !this.isFirstWatch) {
          this.isFirstWatch = true;
          if (this.$route.params.type) {
            this.changeMode(this.$route.params.type);
          } else {
            if (this.account.id) {
              localStorage.setItem(
                `calendar_page_type_${this.account.id}`,
                this.mode
              );
            }
            Vue.router.push({
              name: "calendar.type",
              params: { type: this.mode },
            });
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    loadMoreRentals() {
      this.rentalsFilteredCount += 10;
    },
    prepare_data(response, defaultResponse = false) {
      this.rentalsFilteredCount = 10;
      if (response.data.rentals && response.data.rentals.length === 0) {
        this.rentalsFilteredOnCalendarNoRentals = true;
        this.rentalsFilteredOnCalendar = [];
        return;
      }
      this.rentalsFilteredOnCalendarNoRentals = false;
      if (
        // Selected rentals not found, reseting to no selection
        Object.keys(this.checkedRentals).length > 0 &&
        !Object.keys(response.data.rentals).length
      ) {
        this.saveCheckedRentalIds([]);
        this.get_rentals();
      }

      this.rentalsFilteredOnCalendar = [];
      const keys = Object.keys(response.data.rentals).sort();
      keys.forEach((key) => {
        this.rentalsFilteredOnCalendar.push(response.data.rentals[key]);
      });

      this.rentalsFilteredOnCalendar.sort((a, b) => a.order - b.order);
      if (defaultResponse) {
        this.rentals = this.rentalsFilteredOnCalendar;
      }
    },
    get_rentals(from = "", to = "", activeRentalId = null, activeRate = null) {
      if (this.mode === "month" && !from && !to) {
        from = this.currentMonthStartDay;
        to = this.nextMonthStartDay;
      }
      if (this.mode === "agenda" && !from && !to) {
        if (!this.week_days.length) {
          this.week_days = this.daysOfWeek(new Date());
        }
        from = this.week_days[0];
        to = this.week_days[this.week_days.length - 1];
      }
      this.onceWatchedInMounted = 0;
      this.loading = true;

      let stringQuery = "";
      let keys = this.getSavedRentalIds();
      this.saveCheckedRentalIds(keys);

      if (!this.rentalsFilteredOnCalendarValue) {
        for (const key of keys) {
          if (this.checkedRentals[key]) {
            if (stringQuery === "") {
              stringQuery += `rental_ids[]=${key}`;
            } else {
              stringQuery += `&rental_ids[]=${key}`;
            }
          }
        }
      }

      stringQuery += `&search=${this.rentalsFilteredOnCalendarValue}`;
      let url = `/get-calendars?${stringQuery}`;
      if (from.length > 0) {
        url += `&from=${from}`;
      }
      if (to.length > 0) {
        url += `&to=${to}`;
      }
      this.updateGroupCheckedStatus();

      // TODO Create service for get rentals for calendar tab
      Vue.$http.get(url).then((response) => {
        if (response && response.status === 200) {
          this.prepare_data(response, true);

          this.array_dates = [];
          this.array_correct_dates = [];
          this.months_with_days = [];

          const sliceFrom = parseInt(response.data.month_numbers[0]) - 1;
          const sliceTo = parseInt(
            response.data.month_numbers[response.data.month_numbers.length - 1]
          );
          if (sliceFrom > sliceTo) {
            if (
              parseInt(response.data.month_numbers[sliceTo]) < sliceFrom &&
              sliceFrom != 12
            ) {
              this.months = this.$t("months").slice(sliceFrom, 12);
              this.months.push(this.$t("months")[0]);
              this.months.push(this.$t("months")[1]);
            } else if (
              parseInt(response.data.month_numbers[sliceTo]) < sliceFrom &&
              sliceFrom == 12
            ) {
              this.months = this.$t("months").slice(0, 3);
            } else {
              this.months = this.$t("months").slice(
                sliceFrom,
                parseInt(response.data.month_numbers[sliceTo])
              );
              this.months.push(this.$t("months")[sliceTo - 1]);
            }
          } else {
            this.months = this.$t("months").slice(
              parseInt(response.data.month_numbers[0]) - 1,
              parseInt(
                response.data.month_numbers[
                  response.data.month_numbers.length - 1
                ]
              )
            );
          }

          this.month_numbers = response.data.month_numbers;
          this.years = response.data.years;
          this.from = response.data.from;
          this.to = response.data.to;
          if (this.mode === "agenda") {
            let agendaBookings = [];
            Object.values(response.data.rentals).map((rental) => {
              if (rental.bookings.length > 0) {
                rental.bookings.map((booking) => (booking.rental = rental));
                agendaBookings = [...agendaBookings, ...rental.bookings];
              }
            });

            this.agentaBookings = agendaBookings;
          }

          // this.week_days = this.daysOfWeek(new Date());
          for (let i = 0; i < this.months.length; i++) {
            this.months_with_days[this.months[i]] = this.daysInMonth(
              this.month_numbers[i],
              this.years[i]
            );
          }

          this.initPriceSetup();
          this.loading = false;
          $(".calendar-scrolled-header").remove();
        }
      });
    },
    checkIfMonthInNextYear(index) {
      //TODO: improve this part ???
      // console.log(index);
      const vm = this;
      const sliceFrom = parseInt(vm.month_numbers[0]) - 1;
      const sliceTo = parseInt(vm.month_numbers[vm.month_numbers.length - 1]);
      let months = [];
      if (sliceFrom > sliceTo) {
        if (
          parseInt(vm.month_numbers[sliceTo]) < sliceFrom &&
          sliceFrom != 12
        ) {
          months = vm.$t("months").slice(sliceFrom, 12);
          months.push(vm.$t("months")[0]);
          months.push(vm.$t("months")[1]);
        } else if (
          parseInt(vm.month_numbers[sliceTo]) < sliceFrom &&
          sliceFrom == 12
        ) {
          months = vm.$t("months").slice(0, 3);
        } else {
          months = vm
            .$t("months")
            .slice(sliceFrom, parseInt(vm.month_numbers[sliceTo]));
          months.push(vm.$t("months")[sliceTo - 1]);
        }
      } else {
        months = vm
          .$t("months")
          .slice(
            parseInt(vm.month_numbers[0]) - 1,
            parseInt(vm.month_numbers[vm.month_numbers.length - 1])
          );
      }
      return months[index];
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    },
    daysOfWeek(current) {
      const week = new Array();
      // Starting Monday not Sunday
      current.setDate(current.getDate() - current.getDay() + 1);
      for (let i = 0; i < 7; i++) {
        week.push(moment(new Date(current), "YYYY-MM-DD").format("YYYY-MM-DD"));
        current.setDate(current.getDate() + 1);
      }
      return week;
    },
    checkCheckingDate(date, bookings) {
      const classN = {
        className: "",
        styleName: "",
        existing: false,
      };
      if (!date) {
        return "N/A";
      }
      for (let i = 0; i < bookings.length; i++) {
        if (bookings[i].checking.replace(/-/g, "") == date) {
          if (bookings[i].color) {
            classN.styleName = `background-color: ${bookings[i].color}`;
          }
          classN.existing = true;
          break;
        }
      }
      if (classN.existing) {
        classN.className = "-b needsclick border-red";
      }
      return classN;
    },
    getBorderStyle(date, bookings) {
      if (!date) {
        return "N/A";
      }
      let styleName = "";
      const length = bookings.length;
      for (let i = 0; i < length; i++) {
        const checkin = bookings[i].checking.replace(/-/g, "");
        const checkout = bookings[i].checkout.replace(/-/g, "");
        if (
          (date > checkin && date < parseInt(checkout)) ||
          (date == parseInt(checkout) && checkout != checkin)
        ) {
          if (bookings[i].color) {
            styleName = `border-color: ${bookings[i].color}`;
          }
          break;
        }
      }
      return styleName;
    },
    updateCellSize() {
      const td = document.querySelector("td[data-td-date]");
      if (td && this.cellSize != td.offsetWidth) {
        this.cellSize = td.offsetWidth;
      }
    },
    currentMonthHasBookings(bookings, month, year, fakeRentalId = null) {
      month = parseInt(month) - 1;
      const startOfMonth = moment()
        .month(month)
        .year(year)
        .startOf("month")
        .format("YYYY-MM-DD");
      const endOfMonth = moment()
        .month(month)
        .year(year)
        .endOf("month")
        .format("YYYY-MM-DD");
      const newBookings = bookings.filter(
        (booking) =>
          moment(booking.checking).isBetween(
            startOfMonth,
            endOfMonth,
            null,
            []
          ) ||
          (moment(booking.checking).isBefore(startOfMonth) &&
            moment(booking.checkout).isSameOrAfter(startOfMonth))
      );

      if (!fakeRentalId || (fakeRentalId && newBookings.length > 0)) {
        return true;
      }

      return false;
    },
    checkCheckingBlockedDate(
      date,
      blocked_dates,
      checkDateVar,
      activeRateId,
      rentalUserPlanId = null
    ) {
      if (!date) {
        return "N/A";
      }
      let availabilityKey = "i";
      // if (
      //   this.account.plan_id === 4 ||
      //   (this.account.is_team_member && rentalUserPlanId === 4)
      // ) {
      //   if (activeRateId) {
      //     availabilityKey = `i_${activeRateId}`;
      //   }
      // }
      let exists = false;

      const prevDay = moment(date, "YYYYMMDD")
        .subtract(1, "days")
        .format("YYYYMMDD");
      const nextDay = moment(date, "YYYYMMDD")
        .add(1, "days")
        .format("YYYYMMDD");
      if (
        (!this.account.is_team_member && this.account.plan_id !== 4) ||
        (rentalUserPlanId !== 4 && this.account.is_team_member)
      ) {
        if (
          blocked_dates &&
          blocked_dates.json &&
          blocked_dates.json[date] &&
          blocked_dates.json[date].i == 0 &&
          blocked_dates.json[prevDay] &&
          blocked_dates.json[nextDay] &&
          (blocked_dates.json[prevDay].i != 0 ||
            (blocked_dates.json[prevDay].i == 0 &&
              blocked_dates.json[nextDay].i == 0) ||
            blocked_dates.json[nextDay].i != 0)
        ) {
          exists = true;
        }
      } else if (
        blocked_dates &&
        blocked_dates.json &&
        blocked_dates.json[date] &&
        blocked_dates.json[date][availabilityKey] == 0 &&
        ((blocked_dates.json[prevDay] &&
          blocked_dates.json[nextDay] &&
          (blocked_dates.json[nextDay][availabilityKey] == 0 ||
            blocked_dates.json[nextDay][availabilityKey] != 0)) ||
          !blocked_dates.json[prevDay] ||
          (blocked_dates.json[prevDay] &&
            (!blocked_dates.json[prevDay].hasOwnProperty(availabilityKey) ||
              blocked_dates.json[prevDay][availabilityKey] > 0)))
      ) {
        exists = true;
      }
      return exists;
    },
    getWidth(date, booking) {
      const checkout = moment(booking.checkout, "YYYY-MM-DD");
      const checking = moment(booking.checking, "YYYY-MM-DD");
      let nights = 0;
      const isSameMonth = checking.isSame(checkout, "month");
      nights = !isSameMonth
        ? checkout.diff(date, "days")
        : checkout.diff(checking, "days");
      let width = 0;
      if (nights > 0) {
        width = !isSameMonth
          ? nights * 46
          : nights * this.cellSize - (this.cellSize / 3) * 2;
      } else {
        width = this.cellSize;
      }
      if (!isSameMonth && checkout.isSame(date, "day")) {
        return "width: 0px; min-width: 0px; height: 0px !important";
      }
      return `width: 15.21%; min-width: ${width}px`;
    },
    getBlockedWidth(date, blocked_date) {
      const checking = blocked_date.start;
      const checkout = blocked_date.close;
      const nights =
        moment(checkout, "YYYY-MM-DD").format("DD") -
        moment(checking, "YYYY-MM-DD").format("DD");
      let width = 0;
      width = nights > 0 ? nights * 38 - nights * 20 : 25;

      return `width: 2.21%; min-width: ${5}px`;
    },
    isValidDates(date, booking) {
      return date == booking.checking.replace(/-/g, "");
    },
    isValidDatesNextMonth(date, booking) {
      const vm = this;
      const prevDay = moment(date, "YYYYMMDD")
        .subtract(1, "days")
        .format("YYYYMMDD");
      const currentMonth = moment(date, "YYYYMMDD").format("M");
      const prevMonth = moment(date, "YYYYMMDD")
        .subtract(1, "days")
        .format("M");
      if (
        date >= booking.checking.replace(/-/g, "") &&
        date <= booking.checkout.replace(/-/g, "")
      ) {
        if (
          prevDay >= booking.checking.replace(/-/g, "") &&
          prevDay <= booking.checkout.replace(/-/g, "")
        ) {
          if (prevMonth != currentMonth) {
            return true;
          }
        }
      }
      return false;
    },
    isValidBlockedDates(date, blocked_date) {
      return !(blocked_date && blocked_date.json && !blocked_date.json[date]);
    },
    checkDate(
      date,
      bookings,
      blocked_dates,
      checkCheckingDateVar,
      activeRateId = null,
      rentalUserPlanId = null
    ) {
      const nextDay = moment(date, "YYYYMMDD")
        .add(1, "days")
        .format("YYYYMMDD");
      const prevDay = moment(date, "YYYYMMDD")
        .subtract(1, "days")
        .format("YYYYMMDD");
      const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
      let availabilityKey = "i";
      let priceKey = "p1";
      let minStayKey = "m";
      let maxStayKey = "mx";
      let singleUseKey = "s";
      let overrideKey = "ov";
      // if ((!this.account.is_team_member && this.account.plan_id === 4) || (this.account.is_team_member && rentalUserPlanId === 4)) {
      //   if (activeRateId) {
      //     availabilityKey = `i_${activeRateId}`;
      //     priceKey = `p1_${activeRateId}`;
      //     singleUseKey = `s_${activeRateId}`;
      //     minStayKey = `m_${activeRateId}`;
      //     maxStayKey = `mx_${activeRateId}`;
      //     overrideKey = `ov_${activeRateId}`;
      //   }
      // }

      let bookingIsset = false;
      const classN = {
        class: "",
        price: "",
        priceAll: "",
        style: "",
      };
      const length = bookings.length;
      for (let i = 0; i < length; i++) {
        const checking = bookings[i].checking.replace(/-/g, "");
        const checkout = bookings[i].checkout.replace(/-/g, "");
        if (checkout == date && checking != checkout) {
          if (bookings[i].color) {
            classN.style = `background-color: ${bookings[i].color}`;
          }
          classN.class = "b-";
          break;
        } else if (date > checking && date < checkout) {
          if (bookings[i].color) {
            classN.style = `background-color: ${bookings[i].color}`;
          }
          classN.class = "b ";
          bookingIsset = true;
          break;
        }
      }
      if (blocked_dates && blocked_dates.json[date]) {
        if (blocked_dates.json[date][minStayKey] > 0) {
          classN.minStay = blocked_dates.json[date][minStayKey];
          classN.priceAll = JSON.stringify(blocked_dates.json[date]);
        }
        if (
          (!this.account.is_team_member && this.account.plan_id === 4) ||
          (this.account.is_team_member && rentalUserPlanId === 4)
        ) {
          if (
            blocked_dates.json[date][maxStayKey] &&
            blocked_dates.json[date][maxStayKey] > 0
          ) {
            classN.maxStay = blocked_dates.json[date][maxStayKey];
          }
          if (
            blocked_dates.json[date][overrideKey] &&
            blocked_dates.json[date][overrideKey] > 0
          ) {
            classN.overrideStatus = blocked_dates.json[date][overrideKey];
          }
          if (blocked_dates.json[date].i != null) {
            classN.inventoryNumber = parseInt(blocked_dates.json[date].i);
          }
          if (blocked_dates.json[date][singleUseKey]) {
            classN.singleUseNumber = blocked_dates.json[date][singleUseKey];
          }
        }
      }

      if (!checkCheckingDateVar && !bookingIsset) {
        if (
          blocked_dates &&
          date != today &&
          blocked_dates.json &&
          blocked_dates.json[date] &&
          blocked_dates.json[date][availabilityKey] <= 0 &&
          !blocked_dates.json[prevDay]
        ) {
          classN.class = "-blocked";
        }
      }
      if (classN.class == "") {
        if (
          (!this.account.is_team_member && this.account.plan_id !== 4) ||
          (this.account.is_team_member && rentalUserPlanId !== 4)
        ) {
          if (
            blocked_dates &&
            blocked_dates.json[date] &&
            blocked_dates.json[date].i <= 0 &&
            blocked_dates.json[nextDay] &&
            blocked_dates.json[nextDay].i <= 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay].i <= 0
          ) {
            if (
              !checkCheckingDateVar &&
              blocked_dates.json[prevDay].i <= 0 &&
              blocked_dates.json[prevDay].p1
            ) {
              classN.class = "blocked";
            } else {
              classN.class = "blocked-";
            }
          } else if (
            blocked_dates &&
            blocked_dates.json[date] &&
            blocked_dates.json[date].i <= 0 &&
            blocked_dates.json[nextDay] &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay].i <= 0 &&
            (blocked_dates.json[nextDay].i > 0 ||
              blocked_dates.json[nextDay].i <= 0)
          ) {
            classN.class = "blocked-";
          }
          if (
            blocked_dates &&
            blocked_dates.json &&
            blocked_dates.json[date] &&
            blocked_dates.json[date].i > 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay].i <= 0
          ) {
            classN.class = "blocked-";
          } else if (
            blocked_dates &&
            blocked_dates.json &&
            blocked_dates.json[date] &&
            blocked_dates.json[date].i <= 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay].i <= 0
          ) {
            if (!checkCheckingDateVar) {
              classN.class = "blocked";
            } else {
              classN.class = "blocked-";
            }
          }
        } else {
          if (
            blocked_dates &&
            blocked_dates.json[date] &&
            blocked_dates.json[date][availabilityKey] <= 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay][availabilityKey] <= 0 &&
            ((blocked_dates.json[nextDay] &&
              blocked_dates.json[nextDay][availabilityKey] <= 0) ||
              !blocked_dates.json[nextDay] ||
              (blocked_dates.json[nextDay] &&
                !blocked_dates.json[nextDay].hasOwnProperty(availabilityKey)))
          ) {
            if (
              !checkCheckingDateVar &&
              blocked_dates.json[prevDay] &&
              blocked_dates.json[prevDay][availabilityKey] <= 0
            ) {
              classN.class = "blocked";
            } else {
              classN.class = "blocked-";
            }
          } else if (
            blocked_dates &&
            blocked_dates.json[date] &&
            blocked_dates.json[date][availabilityKey] <= 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay][availabilityKey] <= 0 &&
            ((blocked_dates.json[nextDay] &&
              blocked_dates.json[nextDay][availabilityKey] > 0) ||
              blocked_dates.json[nextDay][availabilityKey] <= 0)
          ) {
            classN.class = "blocked-";
          } else if (
            blocked_dates &&
            (!blocked_dates.json[date] ||
              (blocked_dates.json[date] &&
                !blocked_dates.json[date].hasOwnProperty(availabilityKey))) &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay][availabilityKey] <= 0
          ) {
            classN.class = "blocked-";
          }
          if (
            blocked_dates &&
            blocked_dates.json &&
            blocked_dates.json[date] &&
            blocked_dates.json[date][availabilityKey] > 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay][availabilityKey] <= 0
          ) {
            classN.class = "blocked-";
          } else if (
            blocked_dates &&
            blocked_dates.json &&
            blocked_dates.json[date] &&
            blocked_dates.json[date][availabilityKey] <= 0 &&
            blocked_dates.json[prevDay] &&
            blocked_dates.json[prevDay][availabilityKey] <= 0
          ) {
            if (!checkCheckingDateVar) {
              classN.class = "blocked";
            } else {
              classN.class = "blocked-";
            }
          }
        }
        if (blocked_dates && blocked_dates.json[date]) {
          classN.price = blocked_dates.json[date][priceKey];
          classN.priceAll = JSON.stringify(blocked_dates.json[date]);
        }
      } else if (
        classN.class != "b " &&
        blocked_dates &&
        blocked_dates.json[date]
      ) {
        classN.price = blocked_dates.json[date][priceKey];
        classN.priceAll = JSON.stringify(blocked_dates.json[date]);
      }

      return classN;
    },
    checkPayed(date, bookings) {
      const length = bookings.length;
      for (let i = 0; i < length; i++) {
        const checking = parseInt(bookings[i].checking.replace(/-/g, ""));
        const checkout = parseInt(bookings[i].checkout.replace(/-/g, ""));
        if (date >= checking && date <= checkout) {
          if (bookings[i].payment_is_done == 1 && bookings[i].status != 0) {
            return true;
          }

          return false;
        }
      }
    },
    isWrongBorder(date, bookings) {
      const length = bookings.length;
      for (let i = 0; i < length; i++) {
        const checking = parseInt(bookings[i].checking.replace(/-/g, ""));
        if (
          date == checking &&
          bookings[i].payment_is_done == 1 &&
          bookings[i].status != 0
        ) {
          return true;
        }
      }
      return false;
    },
    checkDate1(date, bookings) {
      let classN = "";
      const length = bookings.length;
      for (let i = 0; i < length; i++) {
        const checking = parseInt(bookings[i].checking.replace(/-/g, ""));
        const checkout = parseInt(bookings[i].checkout.replace(/-/g, ""));
        if (checkout == date && checking != checkout) {
          classN = "b-";
        }
      }
      return classN;
    },
    async showDetail(booking, rental, event = false) {
      const vm = this;
      this.bookingUrl = this.getBookingUrl(booking, rental);
      vm.bookingDetails = true;
      vm.booking = booking;
      vm.selectedBookingRental = vm.booking.rental;
      vm.guest = booking.guest;
      vm.rental = rental;
      vm.channel = booking.channel;
      if (vm.user && vm.user.rights) {
        const rights = Object.values(vm.user.rights);
        const rightExists = rights.find(
          (item) => item.parent_id === vm.rental.user_id
        );
        vm.showBookingActions = rightExists && rightExists.booking_actions;
        vm.showBookingPrices = rightExists && rightExists.booking_prices;
      }

      if (vm.rentals && vm.rentals.length > 0) {
        vm.rentals.map((rental) => {
          if (rental.id === booking.rental_id) {
            if (rental.the_keys_locks && rental.the_keys_locks.length > 0) {
              booking.areLocksConnectedToBookingRental = true;
            } else {
              booking.areLocksConnectedToBookingRental = false;
            }
          }
        });
      } else {
        booking.areLocksConnectedToBookingRental = false;
      }
      $(".panel-overlay").fadeIn();
      $(".calendar-month-view .panel").addClass("active");
      $(".calendar-month-view .panel").css({ right: "0" });
      $(".pannel_sec_second").css({ right: "-350px" });
      $(".edit-price-view .panel-price").css({ right: "-350px" });

      vm.paymentStatus = booking.payment_is_done === 1 ? "OK" : "KO";
      vm.depositStatus =
        booking.statusCode !== 14 && booking.deposit_is_done === 1
          ? "OK"
          : "KO";

      await bookingService.getBookingsSelectedDay(
        this,
        booking.checking,
        [],
        true
      );
      await bookingService.getBookingsSelectedDay(
        this,
        booking.checkout,
        [],
        true
      );

      if (event) {
        event.stopPropagation();
      }
    },
    showDetail2(booking) {
      const vm = this;
      vm.booking = booking;
      vm.guest = booking.guest;
      vm.rental = booking.rental;
      vm.channel = booking.channel;

      const $slider = $(".pannel_sec_second");
      $slider.animate({
        right: parseInt($slider.css("right"), 10) == -350 ? 0 : -350,
      });
    },
    closeDetailModal() {
      const vm = this;
      $(".calendar-month-view .panel").removeClass("active");
      $(".panel-overlay").fadeOut();
      $(".pannel_sec_second").css({ right: "-350px" });
      vm.bookingDetails = false;
    },
    toBookingItemMessages(id) {
      const vm = this;
      vm.closeDetailModal();
      Vue.router.push({
        name: "bookings.details",
        params: { id },
      });
    },
    toBooking(id, tab, isViewBooking = false) {
      this.closeDetailModal();
      if (!isViewBooking) {
        Vue.router.push({
          name: "bookings.details.tab",
          params: { id, tab },
        });
      }
    },
    nextWeek(date) {
      const vm = this;
      const current = new Date(date);
      current.setDate(current.getDate() + 1);
      vm.week_days = this.daysOfWeek(current);
      this.get_rentals(vm.week_days[0], vm.week_days[vm.week_days.length - 1]);
    },
    prevWeek(date) {
      const vm = this;
      const current = new Date(date);
      current.setDate(current.getDate() - 3);
      vm.week_days = this.daysOfWeek(current);
      this.get_rentals(vm.week_days[0], vm.week_days[vm.week_days.length - 1]);
    },
    changeMode(mode) {
      if (mode) {
        const modes = [
          "annual",
          "agenda",
          "month",
          "current",
          "schedule",
          "tasks",
        ];

        // send mixpanel event
        switch (mode) {
          case "tasks":
            mixpanel.track("web.tasks");
            break;
          case "agenda":
            mixpanel.track("web.calendar.week");
            break;
          case "current":
            mixpanel.track("web.calendar.day");
            break;
          case "month":
            mixpanel.track("web.calendar.month");
            break;
          case "annual":
            mixpanel.track("web.calendar.trimestre");
            break;
        }

        if (modes.includes(mode)) {
          this.mode = mode;
          if (this.account.id) {
            this.accountIsGot = true;
            localStorage.setItem(`calendar_page_type_${this.account.id}`, mode);
          }
          switch (mode) {
            case "annual":
            case "agenda":
              $("#wrapper-scroll").scrollLeft(0);
              this.get_rentals();
              break;
            case "month":
            case "current":
            case "schedule":
            case "tasks":
              this.get_rentals();
              break;
            default:
              this.loading = false;
              Vue.router.push({
                name: "calendar.type",
                params: { type: this.mode },
              });
          }
        }
        history.pushState(null, null, `#/calendar/${this.mode}`);
      }
    },
    changeStatus(event, booking) {
      const data = {};
      data.id = booking.id;
      if (event === "payment") {
        data.payment = this.paymentStatus;
      } else if (event === "deposit") {
        data.deposit = this.depositStatus;
      }
      bookingService.changeEventStatuses(this, data, event, booking);
    },
    scrollMonth() {
      const monthCount = this.months.length;
      const position = $("#wrapper-scroll").scrollLeft();
      const middleWidth = 10;

      const calWidth0 = $("#table_calendar-0").width();
      const calWidth1 = $("#table_calendar-1").width();
      const calWidth2 = $("#table_calendar-2").width();
      const calWidth3 = $("#table_calendar-3").width();
      const calWidth4 = $("#table_calendar-4").width();
      const calWidth5 = $("#table_calendar-5").width();

      if (position >= 0 && position < calWidth0) {
        $("#month-0").css("margin-left", position + middleWidth);
        this.currentMonth = 1;
      } else if (position >= calWidth0 && position < calWidth1 + calWidth0) {
        $("#month-1").css("margin-left", position - calWidth0 + middleWidth);
        this.currentMonth = 2;
      } else if (
        position >= calWidth0 + calWidth1 &&
        position < calWidth0 + calWidth1 + calWidth2
      ) {
        $("#month-2").css(
          "margin-left",
          position - (calWidth0 + calWidth1 - middleWidth)
        );
        this.currentMonth = 3;
      } else if (
        position >= calWidth0 + calWidth1 + calWidth2 &&
        position < calWidth0 + calWidth1 + calWidth2 + calWidth3
      ) {
        $("#month-3").css(
          "margin-left",
          position - (calWidth0 + calWidth1 + calWidth2 - middleWidth)
        );
        this.currentMonth = 4;
      } else if (
        position >= calWidth0 + calWidth1 + calWidth2 + calWidth3 &&
        position < calWidth0 + calWidth1 + calWidth2 + calWidth3 + calWidth4
      ) {
        $("#month-4").css(
          "margin-left",
          position -
            (calWidth0 + calWidth1 + calWidth2 + calWidth3 - middleWidth)
        );
        this.currentMonth = 5;
      } else if (
        position >= calWidth0 + calWidth1 + calWidth2 + calWidth3 + calWidth4 &&
        position <
          calWidth0 + calWidth1 + calWidth2 + calWidth3 + calWidth4 + calWidth5
      ) {
        $("#month-5").css(
          "margin-left",
          position -
            (calWidth0 +
              calWidth1 +
              calWidth2 +
              calWidth3 +
              calWidth4 -
              middleWidth)
        );
        this.currentMonth = 6;
      }
    },
    showPriceModal(rental, startDate) {
      this.priceError = null;
      let restrictions = [];
      if (this.hasPlanIdFourAccess(rental)) {
        restrictions =
          rental && rental.restrictions && rental.restrictions.json;
      } else {
        restrictions = rental && rental.room_dates && rental.room_dates.json;
      }
      this.editPrice.startDate = startDate;
      this.editPrice.rental_id = rental.id;
      this.editPrice.availability = 1;
      let priceKey = "p1";
      // if (this.account.plan_id === 4 && rental && rental.booking_rate_id) {
      //   priceKey = `p1_${rental.booking_rate_id}`;
      // }
      this.editPrice.price = this.getRestrictionNumberForSelectedRange(
        restrictions,
        this.editPrice.startDate,
        this.editPrice.startDate,
        priceKey
      );
      if (!rental.id || rental.rental_fake_id) {
        return;
      }
      this.showSelectDateModal(rental.id);
    },
    showSelectDateModal(
      rentalId,
      minStayCellClicked = false,
      maxStayCellClicked = false,
      overrideCellClicked = false,
      inventoryCellClicked = false,
      singleUseCellClicked = false
    ) {
      const user = store.state.account;
      if (
        !user.is_team_member ||
        (user.is_team_member && this.checkTeamMemberAccessToActions(rentalId))
      ) {
        const rental = this.rentals.find((rental) => rental.id === rentalId);
        this.initAndOpenRightPanel(
          rental,
          minStayCellClicked,
          maxStayCellClicked,
          overrideCellClicked,
          inventoryCellClicked,
          singleUseCellClicked
        );
        $(".panel-overlay").fadeIn();
      }
    },
    selectDate(date, rental) {
      const vm = this;
      $(`.${date}-${rental.id}`).css({ "background-color": "#b9c0d1" });
      vm.showSelectDateModal();
    },
    nextMonths() {
      const endDate = moment(this.to);
      let fromDate = endDate.add(this.month_numbers.length, "months");
      fromDate = moment(fromDate).format("YYYY-MM-DD");
      this.rentalsFilteredOnCalendarValue = "";
      this.get_rentals(this.to, fromDate);
    },
    prevMonths() {
      const startDate = moment(this.from);
      let toDate = startDate.subtract(this.month_numbers.length, "months");
      toDate = moment(toDate).format("YYYY-MM-DD");
      this.rentalsFilteredOnCalendarValue = "";
      this.get_rentals(toDate, this.from);
    },
    classForPrice(checkDateVar, checkCheckingDateVar) {
      if (checkDateVar.class !== "b-" && !checkCheckingDateVar) {
        return "checkin-price annual-price-center";
      } else if (checkDateVar.class !== "b " && !checkCheckingDateVar) {
        return "checkin-price";
      }
      return "";
    },
    multiSelectPermission(enableOpenModal) {
      return (
        (this.account.plan_id === 4 || this.account.is_team_member) &&
        !this.enableMultipleModification &&
        this.userAllRentals.length > 1 &&
        !enableOpenModal
      );
    },
    closeEditPriceModal() {
      this.resetRentalConfigData(
        "div.a, div.min-stay-cell",
        ".edit-price-view .panel",
        "editPriceView"
      );
      this.maxStayData.maxStayNumber = "";
      this.resetEditPriceData();
    },
    closeEditRentalMinStayModal() {
      this.resetRentalConfigData(
        "div.min-stay-cell",
        ".edit-rental-min-stay .panel",
        "editRentalMinStay",
        "rentalMinStayData"
      );
      this.rentalMinStayData.minStayNumber = "";
      this.rentalMinStayData.selectedWeekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
      this.rentalMinStayData.weekDays.map((weekDay) => {
        weekDay.selected = true;
      });
    },
    openMultiSelectModal(
      editPrice,
      isOpenModal = false,
      restrictionName,
      enableMultipleModification = false
    ) {
      if (isOpenModal && enableMultipleModification) {
        this.currentRestrictionName = restrictionName;
        this.enableMultipleModification = enableMultipleModification;
        mixpanel.track("web.calendar.update.all");
      } else {
        mixpanel.track("web.calendar.update");
      }
      if (
        (this.account.plan_id === 4 || this.account.is_team_member) &&
        this.enableMultipleModification &&
        this.userAllRentals.length > 1
      ) {
        if (isOpenModal) {
          if (!$("#edit-rentals-price").hasClass("show")) {
            this.openModal("#edit-rentals-price");
          }
          this.enableOpenModal = true;
          if (restrictionName === "price" && editPrice) {
            this.currentRental = editPrice.rental;
            this.priceToEdit = editPrice;
          }
        }
      } else if (restrictionName === "price") {
        this.updatePrice(editPrice);
      }
    },
    closeMultiSelectModal() {
      if (this.priceToEdit && this.currentRestrictionName === "price") {
        this.priceToEdit = {};
      }
      this.enableMultipleModification = false;
      this.enableOpenModal = false;
      this.closeModal("#edit-rentals-price");
      this.currentRestrictionName = "price";
    },
    changeRestriction(rentalsIds) {
      if (rentalsIds.length > 0) {
        switch (this.currentRestrictionName) {
          case "minStay":
            this.minStayRentalsIds = rentalsIds;
            break;
          case "inventory":
            this.inventoryRentalsIds = rentalsIds;
            break;
          case "override":
            this.overrideRentalsIds = rentalsIds;
            break;
          default:
            this.updatePrice(this.priceToEdit, rentalsIds);
        }
        this.currentRestrictionName = "price";
        this.enableMultipleModification = false;
      }
    },

    async updatePrice(editPrice, rentalsIds = []) {
      mixpanel.track("web.calendar.update.minprice");
      if (this.showRestrictionType === "price") {
        if (editPrice.price === "" || editPrice.price === null) {
          this.priceError = "Le prix ne peut pas être vide";
          return;
        }
        if (editPrice.price < 0) {
          this.priceError = "Le prix ne peut pas être négatif";
          return;
        }
      }
      this.priceError = "";
      this.disabledCheckbox = true;
      this.smallLoading = true;
      if (typeof editPrice.startDate === "string") {
        editPrice.startDate = new Date(editPrice.startDate);
      }
      editPrice.startDate = editPrice.startDate
        ? moment(editPrice.startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
        : null;
      editPrice.endDate = editPrice.endDate
        ? moment(editPrice.endDate, "YYYY-MM-DD").format("YYYY-MM-DD")
        : null;
      let roomAvailabilityData = null;

      if (
        (!this.account.is_team_member && this.account.plan_id === 4) ||
        (this.editPrice.rental.user && this.editPrice.rental.user.plan_id === 4)
      ) {
        if (this.showRestrictionType === "price") {
          roomAvailabilityData = {
            startDate: editPrice.startDate,
            endDate: editPrice.endDate,
            rentalId: editPrice.rental_id,
            price: editPrice.price,
            weekDays: [],
          };

          if (rentalsIds.length > 0) {
            roomAvailabilityData.rentalsIds = rentalsIds;
          }

          editPrice.selected_week_days.map((weekDayName) => {
            roomAvailabilityData.weekDays.push(this.weekDaysInfo[weekDayName]);
          });

          await bookingComService.updateRentalPrice(this, roomAvailabilityData);
        }

        if (this.showRestrictionType === "availability") {
          roomAvailabilityData = {
            startDate: editPrice.startDate,
            endDate: editPrice.endDate,
            rentalId: editPrice.rental_id,
            changeAvailability: true,
            status: parseInt(editPrice.availability),
            weekDays: [],
          };

          if (rentalsIds.length > 0) {
            roomAvailabilityData.rentalsIds = rentalsIds;
          }

          editPrice.selected_week_days.map((weekDayName) => {
            roomAvailabilityData.weekDays.push(this.weekDaysInfo[weekDayName]);
          });

          await bookingComService.updateRentalAvailability(
            this,
            roomAvailabilityData
          );
        }
      }

      await this.get_rentals(
        this.from,
        this.to,
        roomAvailabilityData && roomAvailabilityData.rentalId
          ? roomAvailabilityData.rentalId
          : null,
        roomAvailabilityData && roomAvailabilityData.rateId
          ? roomAvailabilityData.rateId
          : null
      );
    },

    selectWeekDays(index, minStay = false) {
      const vm = this;
      vm.editPrice.week_days[index].selected =
        !vm.editPrice.week_days[index].selected;
      vm.editPrice.selected_week_days = [];
      for (let i = 0; i < vm.editPrice.week_days.length; i++) {
        if (vm.editPrice.week_days[i].selected) {
          vm.editPrice.selected_week_days.push(
            vm.editPrice.week_days[i].full_name
          );
        }
      }
    },
    resetEditPriceData() {
      const vm = this;
      vm.editPrice.startDate = "";
      vm.editPrice.endDate = "";
      vm.editPrice.selected_week_days = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
      vm.editPrice.price = "";
      vm.editPrice.default_persone_count = 1;
      vm.editPrice.availability = null;
      vm.onceWatchedInMounted = 0;
      vm.closedEditPriceModal = true;
      vm.editPrice.week_days.map((weekDay) => {
        weekDay.selected = true;
      });
    },
    onChangeFollowUp() {
      const vm = this;
      vm.booking.first_name = vm.booking.guest.first_name;
      vm.booking.last_name = vm.booking.guest.last_name;
      vm.booking.email = vm.booking.guest.email;
      vm.booking.phone = vm.booking.guest.phone;
      bookingService.updateBooking(vm.booking, this);
    },
    refreshBooking() {
      const vm = this;
      vm.openModal(".sync-in-process-modal");
      bookingService.refreshBookings(vm, "calendar");
    },
    async getAccountRights() {
      const vm = this;
      await accountService.getAccountRights(vm);
    },
    getOtherRentals() {
      const vm = this;
      const removed = [];

      // if there are not groups then all rentals will be in 'others' group
      const isGroups = vm.groups.length > 0;
      if (!isGroups) {
        const group = {
          id: 0,
          name: this.$t("groups.all"),
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }

      for (let i = 0; i < vm.rentals.length; i++) {
        const rental = vm.rentals[i];
        for (let j = 0; j < vm.groups.length; j++) {
          const group = vm.groups[j];
          const check = group.rentals.filter((r) => r.id === rental.id);
          if (check.length > 0) {
            const check1 = vm.others.filter((r) => r.id === rental.id);
            if (check1.length > 0) {
              const index = vm.others.indexOf(rental);
              vm.others.splice(index, 1);
              break;
            }
            removed.push(rental);
          } else {
            const check2 = vm.others.filter((r) => r.id === rental.id);
            if (check2.length === 0 && !removed.includes(rental)) {
              vm.others.push(rental);
            }
          }
        }
      }
      // add group with rentals which are not in any groups
      if (isGroups) {
        const group = {
          id: 0,
          name: this.$t("groups.others"),
          rentals: vm.others,
        };
        Vue.set(vm.groups, vm.groups.length, group);
      }
      return vm.others;
    },
    selectGroupForFilter(id, rentalId) {
      if (id != null) {
        const group = this.groups.filter((g) => g.id === id)[0];
        const groupRentals = group.rentals;
        for (let i = 0; i < groupRentals.length; i++) {
          Vue.set(
            this.checkedRentals,
            groupRentals[i].id,
            this.checkedGroups[id]
          );
        }
      }
      this.updateGroupCheckedStatus();
      const rentalIds = [];
      for (const id in this.checkedRentals) {
        if (this.checkedRentals[id] === true) {
          rentalIds.push(parseInt(id));
        }
      }
      this.$refs.dailyCalendar &&
        this.$refs.dailyCalendar.getCurrentBookings(rentalIds);
      this.$refs.scheduleCalendar &&
        this.$refs.scheduleCalendar.getBookingsForSelectedDay(rentalIds);
      if (this.mode === "tasks") {
        this.$refs.tasksCalendar.getTasks();
      }
      this.rentalsFilteredOnCalendarValue = "";
      this.saveCheckedRentalIds(rentalIds);
    },
    removeAllCheckedRentals() {
      this.checkedRentals = [];
      this.checkedGroups = [];
    },
    filterByRentals() {
      this.get_rentals(this.from, this.to);
    },
    checkPlanningAccess() {
      if (this.user.is_team_member) {
        this.user.rights.map((right) => {
          if (right.calendar_planning === 1) {
            this.accessToPlanning = true;
          }
          if (right.calendar_daily === 1) {
            this.accessToDaily = true;
          }
          if (right.calendar_weekly === 1) {
            this.accessToWeekly = true;
          }
          if (right.calendar_annual === 1) {
            this.accessToAnnual = true;
          }
        });
      }
    },
    checkTeamMemberAccessToActions(rentalId, bookingPrices = null) {
      const bookingRightToCheck = bookingPrices
        ? "booking_prices"
        : "booking_actions";
      rentalId = rentalId.toString();
      const user = store.state.account;
      const vm = this;
      let showBookingActions = "";
      let rentalData = "";
      if (user && user.rights && rentalId) {
        const rights = Object.values(user.rights);
        rentalData = vm.rentals.find(
          (rental) => rental.id.toString() === rentalId
        );
        let rightExists = "";
        if (rentalData && rentalData.user_id) {
          rightExists = rights.find(
            (item) => item.parent_id === rentalData.user_id
          );
          showBookingActions = rightExists && rightExists[bookingRightToCheck];
        }
      }
      return showBookingActions;
    },
    hasPriceAccess(rentalId) {
      if (this.user.is_team_member) {
        return this.checkTeamMemberAccessToActions(rentalId, true);
      }
      return true;
    },
    hasPLanAccess(rental) {
      const user = store.state.account;
      if (!user.is_team_member) {
        return !!(user.plan_id && user.plan_id !== 1);
      }
      return !!(
        rental.user &&
        rental.user.plan_id &&
        rental.user.plan_id !== 1
      );
    },
    isCheckoutFirstDayOfMonth(date, bookingChecking, bookingCheckout) {
      const checking = moment(bookingChecking, "YYYY-MM-DD");
      const checkout = moment(bookingCheckout, "YYYY-MM-DD");
      const isSameMonth = checkout.isSame(checking, "month");
      if (!isSameMonth && checkout.isSame(date, "day")) {
        return true;
      }
      return false;
    },
    isCheckinLastDayOfMonth(date, bookingChecking) {
      const checking = moment(bookingChecking, "YYYY-MM-DD");
      const nextDay = moment(bookingChecking, "YYYY-MM-DD").add(1, "days");
      return !checking.isSame(nextDay, "month");
    },
    initRentalConfigPanel(type, rentalId, rental = null) {
      let dataName = "";
      if (type === "minStay") {
        dataName = "rentalMinStayData";
      } else if (type === "maxStay") {
        dataName = "maxStayData";
      } else if (type === "override") {
        dataName = "overrideData";
      } else if (type === "singleUse") {
        dataName = "singleUseData";
      } else {
        dataName = "inventoryData";
      }
      this[dataName].startDate = $("#check_in").val();
      const startDate = new Date(this[dataName].startDate);
      this[dataName].endDate = new Date(startDate.setDate(startDate.getDate()));
      this[dataName].rentalId = rentalId;
      if (rental) {
        this[dataName].rental = rental;
      }
    },
    checkStartDateDisabledDays() {
      const startDate = this.editPrice.startDate;
      if (moment(this.editPrice.endDate).diff(startDate, "days") < 0) {
        this.editPrice.endDate = moment(startDate).add(1, "day").toDate();
      }
      const newDate = new Date(startDate);
      this.endDate.disabled.to = new Date(
        newDate.setDate(newDate.getDate() + this.onceWatchedInMounted)
      );
      if (this.closedEditPriceModal) {
        this.closedEditPriceModal = false;
      } else {
        this.onceWatchedInMounted = 1;
      }
    },
    checkEndDateDisabledDays(editPrice = true) {
      // const endDate = editPrice ? this.editPrice.endDate : this.rentalMinStayData.endDate;
      // const newDate = new Date(endDate);
      // this.startDate.disabled.from = new Date(newDate.setDate(newDate.getDate() - 1));
    },
    syncRoomDates() {
      swal(
        {
          title: this.$t("swal_popup.are_you_sure"),
          text: this.$t("calendar.index.min_stay.sync_info"),
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "btn-warning",
          confirmButtonText: this.$t("button.yes"),
          cancelButtonText: this.$t("swal_popup.cancel"),
          closeOnConfirm: true,
          html: true,
        },
        () => {
          $(".sync-in-process-modal").addClass("show");
          $("body").addClass("modal-open");
          $("body").append('<div class="modal-backdrop fade show"></div>');
          $(".modal-content").css({ display: "block" });
          $(".navbar").css({ "z-index": "0" });
          rentalService.syncRoomDates(this);
        }
      );
    },
    getCurrentDateCheckinsOrCheckoutsCount(
      bookings,
      weekDay,
      type = "checking"
    ) {
      const currentDateActions = bookings.filter((booking) =>
        type === "checking"
          ? booking.checking === weekDay
          : booking.checkout === weekDay
      );
      return currentDateActions.length;
    },
    timeFormat(time) {
      return time.replace(/\s/g, "");
    },
    goToImportPage() {
      Vue.router.push({
        name: "account.settings.tab",
        params: {
          tab: "platforms",
          showAirbnbImport: true,
        },
      });

      $("div.modal-backdrop.fade.show").remove();
    },
    openImportNewRentalsModal() {
      this.$refs.airbnbImportModal.openImportNewRentalsModal();
    },
    closeMaxStayPanel() {
      this.resetRentalConfigData(
        "div.max-stay-cell",
        ".max-stay .max-stay-panel",
        "maxStayPanelOpened",
        "maxStayData"
      );
      this.maxStayData.maxStayNumber = "";
    },
    initAndOpenRightPanel(
      rental,
      minStayCellClicked,
      maxStayCellClicked,
      overrideCellClicked,
      inventoryCellClicked,
      singleUseCellClicked
    ) {
      if (rental) {
        this.currentRental = rental;
        if (minStayCellClicked) {
          this.editRentalMinStay = true;
          this.rentalMinStayData.rentalName = rental && rental.name;
          $(".edit-rental-min-stay").fadeIn();
          $(".edit-rental-min-stay .panel-min-stay").addClass("active");
          $(".edit-rental-min-stay .panel-min-stay").css({ right: "0" });
        } else if (maxStayCellClicked) {
          this.maxStayPanelOpened = true;
          this.maxStayData.rentalName = rental.name;
          $(".max-stay").fadeIn();
          $(".max-stay .max-stay-panel").addClass("active");
          $(".max-stay .max-stay-panel").css({ right: "0" });
        } else if (overrideCellClicked) {
          this.overridePanelOpened = true;
          this.overrideData.rentalName = rental.name;
          $(".override").fadeIn();
          $(".override .override-panel").addClass("active");
          $(".override .override-panel").css({ right: "0" });
        } else if (inventoryCellClicked) {
          this.inventoryPanelOpened = true;
          this.inventoryData.rentalName = rental.name;
          this.inventoryData.default_inventory = rental.default_inventory;
          $(".inventory").fadeIn();
          $(".inventory .inventory-panel").addClass("active");
          $(".inventory .inventory-panel").css({ right: "0" });
        } else if (singleUseCellClicked) {
          this.singleUsePanelOpened = true;
          this.singleUseData.rentalName = rental.name;
          this.singleUseData.rental = rental;
          $(".single-use").fadeIn();
          $(".single-use .single-use-panel").addClass("active");
          $(".single-use .single-use-panel").css({ right: "0" });
        } else {
          this.editPriceView = true;
          this.editPrice.rental = rental;

          if (!this.editPrice.startDate) {
            return;
          }

          $(".edit-price-view").fadeIn();
          $(".edit-price-view .panel-price").addClass("active");
          $(".edit-price-view .panel-price").css({ right: "0" });
        }
      }
    },
    closeOverridePanel() {
      this.resetRentalConfigData(
        "div.override-cell",
        ".override .override-panel",
        "overridePanelOpened",
        "overrideData"
      );
      this.overrideData.status = "";
    },
    resetRentalConfigData(
      cellClassName,
      panelName,
      closedPanelVar,
      dataName = null
    ) {
      this.is_clicked = 0;
      $("#check_in").val("");
      $("#check_out").val("");
      $(".planning-content td").find(cellClassName).removeClass("-s");
      $(".planning-content td").find(cellClassName).removeClass("s-");
      $(".planning-content td").find(cellClassName).removeClass("s");
      $(panelName).removeClass("active");
      $(panelName).css({ right: "-350px" });
      $(".panel-overlay").fadeOut();
      this[closedPanelVar] = false;
      if (dataName) {
        this[dataName].startDate = "";
        this[dataName].endDate = "";
        this[dataName].rentalName = "";
      }
      this.selectedWeekDays = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
      this.weekDays.map((weekDay) => {
        weekDay.selected = true;
      });
    },
    closeInventoryPanel() {
      this.resetRentalConfigData(
        "div.inventory-cell",
        ".inventory .inventory-panel",
        "inventoryPanelOpened",
        "inventoryData"
      );
      this.inventoryData.inventoryNumber = "";
    },
    closeSingleUsePanel() {
      this.resetRentalConfigData(
        "div.single-use-cell",
        ".single-use .single-use-panel",
        "singleUsePanelOpened",
        "singleUseData"
      );
      this.singleUseData.singleUseNumber = "";
    },
    uniqueBookingsList(list) {
      if (this.account.plan_id === 4) {
        const data = new Map();
        list.map((item) => {
          data.set(item.checking, item);
        });
        return [...data.values()];
      }
      return list;
    },
    getRestrictionNumberForSelectedRange(
      restrictions,
      checkin,
      checkout,
      restrictionKey
    ) {
      const checkinDate = moment(checkin).format("YYYYMMDD");
      const checkoutDate = moment(checkout).format("YYYYMMDD");
      if (restrictions) {
        const minStays = [];
        if (
          restrictions.hasOwnProperty(checkinDate) &&
          restrictions.hasOwnProperty(checkoutDate)
        ) {
          for (const index in restrictions) {
            if (index >= checkinDate && index <= checkoutDate) {
              restrictions[index][restrictionKey] &&
              ((restrictions[index][restrictionKey] > 0 &&
                restrictionKey !== "iv") ||
                restrictionKey === "iv")
                ? minStays.push(parseInt(restrictions[index][restrictionKey]))
                : minStays.push(null);
            }
          }
          const allNumbersEqual = minStays.every(
            (value) => value === minStays[0]
          );
          if (allNumbersEqual) {
            return minStays[0];
          }
        }
      }
      return null;
    },
    changeRatePlanCode(rental, activeRateId) {
      rental.booking_rate_id = activeRateId;
      this.$forceUpdate();
    },
    selectRestrictionWeekDays(index, weekDays) {
      this.weekDays[index].selected = !weekDays[index].selected;
      this.selectedWeekDays = [];
      for (let i = 0; i < weekDays.length; i++) {
        if (weekDays[i].selected) {
          this.selectedWeekDays.push(weekDays[i].full_name);
        }
      }
    },
    showOrHideRestrictionRow(all = false, showPriceSetup = false) {
      let isOneRestrictionChecked = false;
      if (all) {
        Object.values(this.restrictions).map((restriction) => {
          restriction.checked = !showPriceSetup;
          if (restriction.checked) {
            isOneRestrictionChecked = true;
          }
        });
      }
      localStorage.setItem(
        `restrictions-${this.account.id}`,
        JSON.stringify(this.restrictions)
      );

      const checkedRestrictions = Object.values(this.restrictions).filter(
        (restriction) => restriction.checked
      );
      this.showPriceSetup = isOneRestrictionChecked
        ? true
        : checkedRestrictions.length === 0
        ? false
        : !showPriceSetup;
    },
    hasAccessToRestrictions(rental, restriction = "minStay") {
      return (
        ((!this.account.is_team_member && this.account.plan_id === 4) ||
          (rental.user && rental.user.plan_id === 4)) &&
        this.showPriceSetup &&
        !rental.rental_fake_id &&
        this.restrictions[restriction].checked
      );
    },
    showRentalRates(rental) {
      return (
        ((!this.account.is_team_member && this.account.plan_id === 4) ||
          (this.account.is_team_member && rental.user.plan_id === 4)) &&
        rental.booking_rate_id &&
        rental.rateCodes &&
        rental.rateCodes.length > 0 &&
        !rental.rental_fake_id
      );
    },
    hasPlanIdFourAccess(rental) {
      return (
        (!this.account.is_team_member && this.account.plan_id === 4) ||
        (this.account.is_team_member &&
          rental.user &&
          rental.user.plan_id === 4)
      );
    },
    hasRentalRestrictionsAccess(rental) {
      return (
        (!this.account.is_team_member && this.account.plan_id === 4) ||
        (this.account.is_team_member && rental.restrictions)
      );
    },
    hasAtLeastOneParentWithPlanIdFour() {
      if (this.account.is_team_member) {
        return this.rentals.filter(
          (rental) => rental.user && rental.user.plan_id === 4
        ).length;
      }
      return this.account.plan_id === 4;
    },
    getTeamMembers(bookingDay) {
      bookingService.getBookingsSelectedDay(this, bookingDay, [], true);
    },
    async addOrChangeTeamMember(bookingId, memberId, type) {
      const data = {
        bookingId,
        memberId,
        type,
      };

      mixpanel.track("web.planning.assign");
      await bookingService.assignTeamMemberToBooking(
        this,
        data,
        null,
        type,
        true
      );
    },
    changeFormStatus(type, booking) {
      const data = {
        id: booking.id,
        welcome_form_submitted: booking.welcome_form_submitted,
        checkin_form_submitted: booking.checkin_form_submitted,
        type,
      };

      formService.changeFormStatus(this, data);
    },
    initPriceSetup() {
      if (this.account.id) {
        const savedRestrictions = localStorage.getItem(
          `restrictions-${this.account.id}`
        )
          ? JSON.parse(localStorage.getItem(`restrictions-${this.account.id}`))
          : null;
        if (savedRestrictions) {
          Object.entries(this.restrictions).map(([key, restriction]) => {
            restriction.checked = savedRestrictions[key]
              ? savedRestrictions[key].checked
              : false;
          });
          const checkedRestrictions = Object.values(savedRestrictions).find(
            (item) => item.checked === true
          );
          this.showPriceSetup = checkedRestrictions
            ? Object.keys(checkedRestrictions).length > 0
            : false;
        }
      }
    },
    saveCheckedRentalIds(rentalIds) {
      if (this.account && this.account.id) {
        localStorage.removeItem(
          `calendar_${this.account.id}_filtered_rental_ids`
        );
        if (rentalIds.length > 0) {
          localStorage.setItem(
            `calendar_${this.account.id}_filtered_rental_ids`,
            rentalIds
          );
        }
      }
    },
    getSavedRentalIds() {
      let keys = "";
      if (this.account && this.account.id) {
        if (
          localStorage.getItem(
            `calendar_${this.account.id}_filtered_rental_ids`
          )
        ) {
          keys = localStorage.getItem(
            `calendar_${this.account.id}_filtered_rental_ids`
          );
          keys = keys.split(",");
          keys.map((index) => {
            this.checkedRentals[index] = true;
          });
        }
      }
      return keys;
    },
    syncRentalReservations() {
      this.openModal("#sync-tmp-change-modal-reservations");
    },
    async syncPricelabPrices() {
      this.loading = true;
      await rentalService.syncPriceLabAllPrices(this.account.id, this);
      this.loading = false;
    },
    syncUserAvailabilities() {
      this.openModal("#sync-tmp-change-modal");
    },
    updateMultiSelectModal() {
      this.isUpdatedValue = true;
      this.enableOpenModal = false;
    },
    updateModal() {
      this.isUpdatedValue = false;
    },
    updateGroupCheckedStatus() {
      for (let i = 0; i < this.groups.length; i++) {
        const group = this.groups[i];
        for (let j = 0; j < group.rentals.length; j++) {
          const rental = group.rentals[j];
          if (!this.checkedRentals[rental.id]) {
            Vue.set(this.checkedGroups, group.id, false);
            break;
          }
          Vue.set(this.checkedGroups, group.id, true);
        }
      }
    },
    getOverrideStatusName(status) {
      let name;
      switch (status) {
        case 1:
          name = this.$t("calendar.index.override.no_checkin");
          break;
        case 2:
          name = this.$t("calendar.index.override.no_checkout");
          break;
        case 3:
          name = "No ch in/out";
          break;
        default:
          name = "";
          break;
      }

      return name;
    },
    getWeekDay(date, month, mod, year) {
      if (!date) {
        return "N/A";
      }

      if (mod === "short") {
        Date.weekDays = this.$t("shortWeekDays");
      } else {
        Date.weekDays = this.$t("weekDays");
      }

      if (date < 10) {
        date = `0${date}`;
      }
      const dtt = new Date(`${year}/${month}/${date}`);
      return Date.weekDays[dtt.getDay()];
    },
    getDateForTitle(date) {
      if (!date) {
        return "N/A";
      }
      return moment.utc(date).format("dddd DD, MMMM YY").toUpperCase();
    },
    getDateForBooking(date) {
      if (!date) {
        return "N/A";
      }
      return moment.utc(date).format("dddd DD, MMMM YY").toUpperCase();
    },
    getDateForRange(date) {
      if (!date) {
        return "N/A";
      }
      const months = this.$t("months");
      const dtt = new Date(date);
      return `${dtt.getDate()} ${months[dtt.getMonth()]} ${dtt.getFullYear()}`;
    },
    getDateForMonth(date) {
      if (!date) {
        return "N/A";
      }
      const months = this.$t("months");
      const dateObj = new Date(date);
      return `${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
    },
    getWeekDayFromDateCalendar(date) {
      moment.locale("fr", {
        months: this.$t("months"),
        weekdaysShort: this.$t("medWeekDays"),
        monthsShort: this.$t("shortMonths"),
      });
      return moment(date).format("ddd DD MMMM . YYYY");
    },
    getYear(date) {
      if (!date) {
        return "N/A";
      }
      return new Date(date).getFullYear();
    },
    getMonthDays(date, month, index, year) {
      if (!date) {
        return "N/A";
      }
      const d = year + month + (date < 10 ? `0${date}` : date);
      const day = `${year}-${month}-${date < 10 ? `0${date}` : date}`;

      if (!this.array_dates[index]) {
        const array = [];
        this.array_dates.push(array);
      }

      if (!this.array_dates[index].includes(d)) {
        this.array_dates[index].push(d);
      }

      if (!this.array_correct_dates[index]) {
        this.array_correct_dates.push([]);
      }

      if (!this.array_correct_dates[index].includes(day)) {
        this.array_correct_dates[index].push(day);
      }

      return `z${d}`;
    },
    getCls(
      date,
      bookings,
      blocked_dates,
      accountPlanId,
      activeRateId = null,
      fakeRentalId = null
    ) {
      if (!date) {
        return "N/A";
      }
      const prevDay = moment(date, "YYYYMMDD")
        .subtract(1, "days")
        .format("YYYYMMDD");
      let className = "g ";
      const length = bookings.length;
      for (let i = 0; i < length; i++) {
        const checkin = bookings[i].checking.replace(/-/g, "");
        const checkout = bookings[i].checkout.replace(/-/g, "");
        if (
          (date > checkin && date < parseInt(checkout)) ||
          (date == parseInt(checkout) && checkout !== checkin)
        ) {
          className += " gb";
          break;
        }
      }
      let availabilityKey = "i";
      // if (accountPlanId === 4) {
      //   if (activeRateId) {
      //     availabilityKey = `i_${activeRateId}`;
      //   }
      // }
      if (
        !className.includes("gb") &&
        blocked_dates &&
        blocked_dates.json[prevDay] &&
        blocked_dates.json[prevDay][availabilityKey] == 0 &&
        ((blocked_dates &&
          blocked_dates.json &&
          blocked_dates.json[date] &&
          blocked_dates.json[date][availabilityKey] == 0) ||
          (blocked_dates &&
            blocked_dates.json &&
            blocked_dates.json[date] &&
            blocked_dates.json[date][availabilityKey] != 0) ||
          (accountPlanId === 4 &&
            (!blocked_dates.json[date] ||
              (blocked_dates.json[date] &&
                (!blocked_dates.json[date].hasOwnProperty(availabilityKey) ||
                  !blocked_dates.json[date][availabilityKey] > 0)))))
      ) {
        className += " db";
      }
      if (fakeRentalId && !className.includes("gb")) {
        className = " g";
      }
      return className;
    },
    getClassForDate(date, month, year) {
      if (!date) {
        return "N/A";
      }

      Date.shortDays = ["S", "M", "T", "W", "T", "F", "S"];

      function shortDays(dt) {
        return Date.shortDays[dt.getDay()];
      }

      const y = new Date().getFullYear();
      if (date < 10) {
        date = `0${date}`;
      }
      let clas = "";
      const dtt = new Date(`${year}/${month}/${date}`);
      if (shortDays(dtt) === "S") {
        clas = "d6";
      } else {
        clas = "d1";
      }

      const today = new Date();
      if (
        today.getDate() == date &&
        month == today.getMonth() + 1 &&
        year == y
      ) {
        clas += " todayBackground";
      }

      return clas;
    },
  },
  async mounted() {
    const vm = this;
    await vm.getAccountRights();
    await vm.checkPlanningAccess();
    await rentalService.getGroups(vm, true, true);
    await vm.getOtherRentals();
    await rentalService.getRentalGroups(this, true, true);

    this.groups.forEach((group) => {
      this.rentalsCount += group.rentals.length;
    });

    this.filteredRentalGroups = this.groups;
    this.rentalsFilteredOnCalendar = this.rentals;

    this.initPriceSetup();

    $(".panel-overlay").click(() => {
      vm.closeDetailModal();
      vm.closeEditPriceModal();
      vm.closeEditRentalMinStayModal();
      vm.closeMaxStayPanel();
      vm.closeOverridePanel();
      vm.closeInventoryPanel();
      vm.closeSingleUsePanel();
    });

    $(document).on("click", ".planning-content td", function (event) {
      const ifChangedFromMinStay = $(this).has("div.min-stay-cell").length > 0;
      const ifChangedFromMaxStay = $(this).has("div.max-stay-cell").length > 0;
      const ifChangedFromOverride = $(this).has("div.override-cell").length > 0;
      const ifChangedFromInventory =
        $(this).has("div.inventory-cell").length > 0;
      const ifChangedFromSingleUse =
        $(this).has("div.single-use-cell").length > 0;

      document.getElementById("check_in").value = moment(
        $(this).data("td-date")
      );
      document.getElementById("check_out").value = moment(
        $(this).data("td-date")
      );

      // document.getElementById("check_in").value = $(this).data("td-date");
      // document.getElementById("check_out").value = $(this).data("td-date");
      if ($(this).has("span.booking-item").length === 0) {
        const tr_id = $(this).parent("tr").attr("id");
        const fakeRentalId = $(this).parent("tr").attr("data-id");
        const rentalid = $(`#${tr_id}`).data("rentalid");
        const rental = vm.rentals.find(
          (rental) => rental.id === rentalid && !rental.rental_fake_id
        );

        if (fakeRentalId) {
          return;
        }
        let restrictions = [];
        if (vm.hasPlanIdFourAccess(rental)) {
          restrictions =
            rental && rental.restrictions && rental.restrictions.json;
        } else {
          restrictions = rental && rental.room_dates && rental.room_dates.json;
        }
        let minStayKey = "m";
        if (ifChangedFromMinStay) {
          // if (vm.account.plan_id === 4 && rental && rental.booking_rate_id) {
          //   minStayKey = `m_${rental.booking_rate_id}`;
          // }
          vm.initRentalConfigPanel("minStay", rentalid, rental);
          vm.rentalMinStayData.minStayNumber =
            vm.getRestrictionNumberForSelectedRange(
              restrictions,
              vm.rentalMinStayData.startDate,
              vm.rentalMinStayData.startDate,
              minStayKey
            );
        } else if (ifChangedFromMaxStay) {
          let maxStayKey = "mx";
          // if (vm.account.plan_id === 4 && rental && rental.booking_rate_id) {
          //   maxStayKey = `mx_${rental.booking_rate_id}`;
          // }
          vm.initRentalConfigPanel("maxStay", rentalid, rental);
          vm.maxStayData.maxStayNumber =
            vm.getRestrictionNumberForSelectedRange(
              restrictions,
              vm.maxStayData.startDate,
              vm.maxStayData.startDate,
              maxStayKey
            );
        } else if (ifChangedFromOverride) {
          let overrideKey = "ov";
          // if (vm.account.plan_id === 4 && rental && rental.booking_rate_id) {
          //   overrideKey = `ov_${rental.booking_rate_id}`;
          // }
          vm.initRentalConfigPanel("override", rentalid, rental);
          vm.overrideData.status = vm.getRestrictionNumberForSelectedRange(
            restrictions,
            vm.overrideData.startDate,
            vm.overrideData.startDate,
            overrideKey
          );
        } else if (ifChangedFromInventory) {
          vm.initRentalConfigPanel("inventory", rentalid);
          vm.inventoryData.inventoryNumber =
            vm.getRestrictionNumberForSelectedRange(
              restrictions,
              vm.inventoryData.startDate,
              vm.inventoryData.startDate,
              "i"
            );
        } else if (ifChangedFromSingleUse) {
          let singleUseKey = "s";
          // if (vm.account.plan_id === 4 && rental && rental.booking_rate_id) {
          //   singleUseKey = `s_${rental.booking_rate_id}`;
          // }
          vm.initRentalConfigPanel("singleUse", rentalid, rental);
          vm.singleUseData.singleUseNumber =
            vm.getRestrictionNumberForSelectedRange(
              restrictions,
              vm.singleUseData.startDate,
              vm.singleUseData.startDate,
              singleUseKey
            );
        } else {
          vm.editPrice.startDate = $("#check_in").val();
          const startDate = new Date(vm.editPrice.startDate);
          vm.editPrice.endDate = new Date(
            startDate.setDate(startDate.getDate() + 1)
          );
          vm.editPrice.rental_id = rentalid;
          vm.editPrice.availability = 1;
          let priceKey = "p1";
          // if (vm.account.plan_id === 4 && rental && rental.booking_rate_id) {
          //   priceKey = `p1_${rental.booking_rate_id}`;
          // }
          vm.editPrice.price = vm.getRestrictionNumberForSelectedRange(
            restrictions,
            vm.editPrice.startDate,
            vm.editPrice.startDate,
            priceKey
          );
        }
        if (!rentalid) {
          return;
        }
        vm.showSelectDateModal(
          rentalid,
          ifChangedFromMinStay,
          ifChangedFromMaxStay,
          ifChangedFromOverride,
          ifChangedFromInventory,
          ifChangedFromSingleUse
        );

        return;
      }

      if (vm.is_clicked !== 0) return;
    });

    if (this.account && this.account.id && !this.isFirstWatch) {
      if (this.$route.params.type) {
        this.changeMode(this.$route.params.type);
      } else {
        localStorage.setItem(
          `calendar_page_type_${this.account.id}`,
          this.mode
        );
        Vue.router.push({
          name: "calendar.type",
          params: { type: this.mode },
        });
      }
    }

    moment.locale(this.language);

    // comment to avoid flickering effect
    // document.onscroll = function () {
    //   const calendarTabs = document.getElementById('header-tabs');
    //   if (calendarTabs) {
    //     if ($(window).scrollTop() < 200) {
    //       console.log('scroll before', $(window).scrollTop());
    //       calendarTabs.style.position = 'initial';
    //       calendarTabs.style.height = 'initial';
    //       calendarTabs.style.top = 'initial';
    //       calendarTabs.style.width = '100%';
    //       $('.page-tabs').css('display', 'block');
    //     } else {
    //       console.log('scroll after', $(window).scrollTop());
    //       $('.page-tabs').css('display', 'none');
    //       // calendarTabs.style.position = 'fixed'; // line that cause flickering effect
    //       calendarTabs.style.width = 'calc(100% - 291px)';
    //       calendarTabs.style.zIndex = '5';
    //       calendarTabs.style.background = '#f3f4f7';
    //       calendarTabs.style.top = '70px';
    //     }
    //   }
    // };

    // this.handleCalendarScroll();
  },
  updated() {
    this.updateCellSize();
  },
  created() {
    window.addEventListener("resize", this.updateCellSize);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateCellSize);
    document.onscroll = function () {
      return false;
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    week_days() {
      return this.daysOfWeek(new Date());
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/calendar/index/index.js